// src/Api/api.js
// 整合的API文件，包含所有API调用和模型服务

import CryptoJS from 'crypto-js';

const domainName = window.location.hostname;
// const isProd = window.location.hostname === 'chat.zhihua.chat';
let normalServiceUrl = domainName === 'localhost' ? '' : 'https://chat.zhihua.chat'; // 开发环境使用代理
let loginService = domainName === 'localhost' ? '' : 'https://chat.zhihua.chat'; // 开发环境使用代理
let chatServiceUrl = "http://127.0.0.1:3010"
let xhsChatServiceUrl = "http://127.0.0.1:3000"
let modelServiceUrl = 'https://zg-cloud-model-service.replit.app';
let wxpayServiceUrl = 'https://wx-pay-116838-7-1320884641.sh.run.tcloudbase.com'
let goBackServiceUrl = 'https://golang-qo9o-116838-7-1320884641.sh.run.tcloudbase.com'

// Model Service 配置
let cozeModelServiceUrl = 'https://api.coze.cn/open_api/v2/chat';
let myToken = 'pat_PAgIS0o4LBBfV9SgMGvgSRA684mB4zf8vfpzxbEotjF5f8t3V4ZH5PnU5LhQXf7u'//pat_p9th9D78zNgfMHpdrDMGUmFhZjvY3ZE0uGP0sfZKumfVYMOEWxhyFyf7hx9Ts2KA pat_PAgIS0o4LBBfV9SgMGvgSRA684mB4zf8vfpzxbEotjF5f8t3V4ZH5PnU5LhQXf7u
const chatbotMap = {
    "keyword": "7398469657676070947",
    "template": "7424471959511269391",
    "message": "7397788287782027304"
}

// 检查localStorage中是否已经存在user_id
const checkAndGenerateUserId = () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    if (userInfo.user_id) {
        return userInfo.user_id;
    }
    const username = userInfo.username;
    if (!username) {
        console.error('Username not found in userInfo');
        // 如果没有username，生成一个默认的user_id
        const defaultUserId = 'default_' + Math.random().toString(36).substring(2, 15);
        userInfo.user_id = defaultUserId;
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        return defaultUserId;
    }
    const userIdHash = CryptoJS.SHA256(username).toString();
    const userId = userIdHash.substring(0, 14);
    userInfo.user_id = userId;
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
    return userId;
}

const generateConversationId = () => {
    return Math.floor(Math.random() * 9999) + 1;
}

const cozeOptions = {
    headers: {
        'Authorization': `Bearer ${myToken}`,
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Host': 'api.coze.cn',
        'Connection': 'keep-alive'
    }
};

// Model Service Functions
export async function postChatModel(query, mode) {
    const data = {
        "conversation_id": generateConversationId().toString(),
        "bot_id": chatbotMap[mode],
        "user": checkAndGenerateUserId(),
        "query": query,
        "stream": false,
    }
    const response = await fetch(`${cozeModelServiceUrl}`, {
        headers: { ...cozeOptions.headers },
        method: 'POST',
        body: JSON.stringify(data),
    });
    const responseData = await response.json();
    return responseData
}

// Login and Authentication Functions
async function loginRequest(url, options = {}) {
    try {
        // 设置默认请求头
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...options.headers
        };
        const response = await fetch(url, {
            ...options,
            headers: headers,
            mode: 'cors',
            credentials: 'omit' // 不发送cookies
        });
        if (response.status === 200) {
            const data = await response.json();
            console.log('登录API响应数据:', data);
            return data;
        } else if (response.status === 401) {
            const errorText = await response.text();
            throw new Error('用户名或密码错误，请检查输入');
        } else if (response.status === 404) {
            throw new Error('登录接口不存在，请联系管理员');
        } else {
            const errorText = await response.text();
            throw new Error(`登录失败: ${response.status} ${response.statusText}`);
        }
        
    } catch (error) {
        throw error;
    }
}

export async function login(username, password) {
    try {
        // 直接请求后端服务器
        const loginUrl = `https://chat.zhihua.chat/login?username=${username}&password=${password}`;  
        return await loginRequest(loginUrl, {
            method: 'POST',
            // 注意：不发送请求体，使用URL参数
        });
        
    } catch (error) {
        throw error;
    }
}

// Token Management
async function getToken() {
    const token = localStorage.getItem('token');
    return token ? `${token}` : null;
}

// Generic API Functions
async function fetchApi(url, options = {}) {
    try {
        const token = await getToken();
        if (token) {
            options.headers = {
                ...(options.headers || {}),
                'Authorization': `Bearer ${token}`  // 添加 Bearer 前缀
            };
        } else {
            window.location.href = '/';
            return
        }

        if (!options.headers['Content-Type']) {
            options.headers['Content-Type'] = 'application/json';
        }

        const fetchOptions = {
            ...options,
            mode: 'cors',
            credentials: 'same-origin'
        };

        const response = await fetch(url, fetchOptions);

        if (response.status === 401) {
            window.location.href = '/';
            return;
        }

        if (response.status !== 200) {
            // 返回错误对象，确保格式一致
            return {
                success: false,
                error: `HTTP ${response.status}: ${response.statusText}`,
                data: null,
                status: response.status,
                msg: 'error'
            };
        }

        const data = await response.json();
        return data;

    } catch (error) {
        return {
            success: false,
            error: error.message || '网络请求失败',
            data: null,
            status: 0,
            msg: 'error'
        };
    }
}

async function fetchLocalApi(url, options = {}) {//专门处理私信的报错
    try {
        // 确保设置Content-Type为application/json
        if (options.method === 'POST' || options.method === 'PUT') {
            options.headers = {
                ...options.headers,
                'Content-Type': 'application/json'
            };
        }

        const response = await fetch(url, options);
        if (response.status === 401) {
            window.location.href = '/';
            return;
        }
        if (response.status !== 200) {
            return response.status
            // throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();

    } catch (error) {
        return 10000
        // throw error;  // 重新抛出错误
    }
}

// API Endpoints
export async function postshortToLongLinks(data) {
    return fetchApi(`${normalServiceUrl}/transform_urls`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function getTaskListApi(offset, count) {
    return fetchApi(`${normalServiceUrl}/task_list?offset=${offset}&count=${count}`, {
      method: 'GET',
    });
}

export async function getCommentListByTaskIdApi(taskId, page, size, filters) {
    const offset = (page - 1) * size;

    // 构建 filters 对象字符串
    const filterStr = filters ? (JSON.stringify(filters)) : '';

    return fetchApi(`${normalServiceUrl}/comments?task_id=${taskId}&offset=${offset}&count=${size}&filters=${filterStr}`, {
        method: 'GET',
    });
}

export async function postTestAnalysisApi(data) {
    return fetchApi(`${normalServiceUrl}/test_analysis`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function startAnalysisApi(data) {
    return fetchApi(`${normalServiceUrl}/analysis`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function stopAnalysisApi(data) {
    return fetchApi(`${normalServiceUrl}/stop_analysis`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function getAnalysisProgressApi(taskId) {
    return fetchApi(`${normalServiceUrl}/progress?task_id=${taskId}&&step_type=2`, {
        method: 'GET',
    });
}

export async function getTaskIdtoDownloadApi(taskId) {
    return fetchApi(`${normalServiceUrl}/crawler_download?task_id=${taskId}`, {
        method: 'GET',
    });
}

export async function getTaskIdAnalysisResultApi(taskId) {
    return fetchApi(`${normalServiceUrl}/analysis_result?task_id=${taskId}`, {
        method: 'GET',
    });
}

export async function postCommentCrawlApi(data) {
    return fetchApi(`${normalServiceUrl}/comment_crawler`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function getMarketListByTaskIdApi(task_id, offset, count) {
    return fetchApi(`${normalServiceUrl}/get_marketing_list?task_id=${task_id}&task_step_type=3&offset=${offset}&count=${count}`, {
        method: 'GET'
    });
}

export async function postAnalysisSatisfactionApi(data) {
    return fetchApi(`${normalServiceUrl}/analyze_points`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function getMarketProgressApi(task_id) {
    return fetchApi(`${normalServiceUrl}/marketing_progress?task_id=${task_id}`, {
        method: 'GET'
    });
}

export async function getMarketResultApi(task_id) {
    return fetchApi(`${normalServiceUrl}/marketing_result?task_id=${task_id}`, {
        method: 'GET'
    });
}

export async function deleteTaskApi(data) {
    return fetchApi(`${normalServiceUrl}/delete_task`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function postKeyword(data) {
    return fetchApi(`${modelServiceUrl}/chat_openai`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function getTemplateApi() {
    return fetchApi(`${normalServiceUrl}/get_analysis_modules`, {
        method: 'GET'
    });
}

export async function createTemplateApi(data) {
    return fetchApi(`${normalServiceUrl}/create_analysis_module`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function deleteTemplateApi(data) {
    return fetchApi(`${normalServiceUrl}/delete_analysis_module`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function updateTemplateApi(data) {
    return fetchApi(`${normalServiceUrl}/update_analysis_module`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function getUserInfo() {
    return fetchApi(`${normalServiceUrl}/user_info`, {
        method: 'GET'
    });
}

export async function getQuote() {
    return fetchApi(`${normalServiceUrl}/quota`, {
        method: 'GET'
    });
}

export async function getUserSatisfactionApi(taskId) {
    return fetchApi(`${normalServiceUrl}/get_user_satisfaction?task_id=${taskId}`, {
        method: 'GET'
    });
}

export async function testUserSatisfactionApi(taskId) {
    return fetchApi(`${normalServiceUrl}/test_user_satisfaction?task_id=${taskId}`, {//TODO:前期存在兼容已有用户的数据
        method: 'GET'
    });
}

export async function postWXPay(data) {
    return fetchApi(`${wxpayServiceUrl}/pay`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function postStartMarketByTaskIdApi(platform, data) {
    const serviceUrl = platform === 'dy' ? chatServiceUrl : xhsChatServiceUrl;
    return fetchApi(`${serviceUrl}/start_marketing`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function postStopMarketByTaskIdApi(platform, data) {
    const serviceUrl = platform === 'dy' ? chatServiceUrl : xhsChatServiceUrl;
    return fetchApi(`${serviceUrl}/stop_marketing`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function getDouyinAccounts() {
    return fetchLocalApi(`${chatServiceUrl}/get_douyin_accounts`, {
        method: 'GET'
    });
}

export async function postLoginDouyin() {
    return fetchLocalApi(`${chatServiceUrl}/login_douyin`, {
        method: 'POST'
    });
}

export async function getXhsAccounts() {
    return fetchLocalApi(`${xhsChatServiceUrl}/get_xhs_accounts`, {
        method: 'GET'
    });
}

export async function getChatVersion() {
    return fetchLocalApi(`${chatServiceUrl}/get_version`, {
        method: 'GET'
    });
}

//保存与task相关的键值对
export async function getKvApi(taskId, jsonKey) {
    return fetchLocalApi(`${goBackServiceUrl}/api/get_kvcache?taskId=${taskId}&jsonKey=${jsonKey}`, {
        method: 'GET'
    });
}

export async function updateKvApi(data) {
    return fetchLocalApi(`${goBackServiceUrl}/api/update_kvcache`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export async function createKvApi(data) {
    return fetchLocalApi(`${goBackServiceUrl}/api/create_kvcache`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

// Get the simple time gap for private messages
export async function getSimpleTimeGap() {
    return fetchLocalApi(`${chatServiceUrl}/get_simple_time_gap`, {
        method: 'GET',
    });
}

// Set the simple time gap for private messages
export async function setSimpleTimeGap(timeGap) {
    return fetchLocalApi(`${chatServiceUrl}/set_simple_time_gap`, {
        method: 'POST',
        body: JSON.stringify({ time_gap: timeGap }),
    });
}

//保存小红书帖子的token
export async function getXhsApi(explore) {
    return fetchLocalApi(`${goBackServiceUrl}/api/xhs/get?explore=${explore}`, {
        method: 'GET'
    });
}

export async function updateXhsApi(data) {
    return fetchLocalApi(`${goBackServiceUrl}/api/xhs/update`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export async function createXhsApi(data) {
    return fetchLocalApi(`${goBackServiceUrl}/api/xhs/create`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export async function updateMarketingUserApi(data) {
    return fetchApi(`${normalServiceUrl}/update_marketing_user`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function batchUpdateMarketingUserApi(data) {
    return fetchApi(`${normalServiceUrl}/batch_update_marketing_user`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function getAccountListApi() {
    return fetchApi(`${normalServiceUrl}/monitor_tasks`, {
        method: 'GET',
    });
}

export async function getUserInfosApi() {
    return fetchApi(`${normalServiceUrl}/user_infos`, {
        method: 'GET',
    });
}

export async function updateUserInfosApi(data) {
    return fetchApi(`${normalServiceUrl}/update_user_info`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
}

export async function getTasksApi(params = {}) {
    return fetchApi(`${normalServiceUrl}/tasks`, {
        method: 'GET',
        params
    });
}

// 导出 fetchApi 函数
export { fetchApi };